// Franse teksten van aanmelden en abonnement (zie billingApp.nl.ts).
export const appBillingFr = {
    signup: {
        steps: [
            'Bienvenue',
            'Compte',
            'Confirmer',
            'Foyer',
            'Membres',
            'Modules',
            'Tableau',
            'Terminé',
        ],
        stepOf: 'Étape {n} sur {total} : {name}',
        welcomeTitle: 'Bienvenue sur AMUMIN Family Board',
        welcomeBody: 'Un tableau calme pour votre foyer : l’agenda, les tâches et plus encore, sur une tablette au mur et dans cette app.',
        trialLine: 'Le premier mois est gratuit. Tu n’as pas besoin de saisir tes données de paiement maintenant.',
        languageLabel: 'Dans quelle langue veux-tu continuer ?',
        start: 'Commencer',
        closedTitle: 'Les inscriptions ne sont pas encore ouvertes',
        closedBody: 'Nous ouvrons bientôt. Inscris-toi sur la liste d’attente, nous t’enverrons une invitation.',
        closedLink: 'Vers la liste d’attente',
        haveAccount: 'Tu as déjà un compte ?',
        login: 'Se connecter',
        accountTitle: 'Ton compte',
        accountBody: 'Il te sert à te connecter. Nous utilisons ton adresse e-mail uniquement pour ton compte, jamais pour de la publicité.',
        name: 'Ton prénom',
        nameHint: 'C’est ainsi que le tableau t’appelle. Modifiable plus tard.',
        nameRequired: 'Saisis ton prénom.',
        email: 'Adresse e-mail',
        method: 'Comment veux-tu te connecter ?',
        methodPassword: 'Avec un mot de passe',
        methodLink: 'Envoie-moi un lien',
        methodLinkHint: 'Tu reçois un code et un bouton par e-mail. Tu pourras toujours choisir un mot de passe plus tard.',
        priceLine: '1 mois gratuit, puis {price} par mois. Tu peux résilier à tout moment.',
        priceLinePlaceholder: '1 mois gratuit, puis tu paies chaque mois. Tu connaîtras le prix bien avant la fin. Tu peux résilier à tout moment.',
        termsBefore: 'J’accepte les',
        termsLink: 'conditions',
        termsAnd: 'et la',
        privacyLink: 'politique de confidentialité',
        termsRequired: 'Coche cette case pour continuer.',
        createAccount: 'Créer le compte',
        verifyTitle: 'Confirme ton adresse e-mail',
        verifyIntro: 'Nous avons envoyé un code à {email}. Saisis-le ci-dessous, ou clique sur le bouton dans l’e-mail.',
        verifyHint: 'Pas d’e-mail ? Regarde aussi dans les indésirables, ou demande un nouveau code ci-dessous.',
        otherEmail: 'Autre adresse e-mail',
        linkBusy: 'Confirmation de ton adresse e-mail…',
        linkVerifiedTitle: 'Ton adresse e-mail est confirmée',
        linkVerifiedBody: 'Ton mois d’essai a commencé. Continue dans le navigateur où tu as commencé, ou connecte-toi ici.',
        linkInvalid: 'Ce lien a expiré ou a déjà été utilisé. Connecte-toi, ou inscris-toi à nouveau.',
        modulesTitle: 'Que veux-tu utiliser ?',
        modulesBody: 'Tout est au choix. Pour votre type de foyer, ceci est déjà activé ; active ou désactive ce que tu veux. Tu pourras toujours le modifier plus tard dans Réglages › Modules.',
        profileTitle: 'Foi, repas et jours particuliers',
        profileBody: 'Seulement si tu le souhaites. Tu choisis toi-même et tu donnes un consentement séparé.',
        profileButton: 'Choisir',
        boardTitle: 'Une tablette comme tableau',
        boardBody: 'Fixe une tablette au mur et associe-la avec le code QR. Pas de tablette sous la main ? Tu peux aussi le faire plus tard, dans Réglages › Tablettes.',
        boardQr: 'Associer avec le code QR',
        boardCode: 'Associer avec un code',
        doneTitle: 'Bienvenue, tout est prêt',
        doneTrial: 'Ton mois d’essai dure jusqu’au {date} inclus.',
        doneNext: [
            'Une semaine avant la fin, nous t’envoyons un rappel.',
            'Tu veux continuer ensuite ? Ajoute tes données de paiement dans Réglages › Abonnement. Si tu ne fais rien, tu peux encore tout consulter, mais plus rien modifier.',
            'Tu peux résilier à tout moment. Nous n’effaçons jamais rien de nous-mêmes.',
        ],
        toApp: 'Vers l’app',
    },
    page: {
        title: 'Abonnement',
        settingsHint: 'Mois d’essai, paiement et factures',
        offTitle: 'Pas encore d’abonnements',
        offBody: 'Tu utilises AMUMIN Family Board pour l’instant sans abonnement.',
        noneTitle: 'Aucun abonnement nécessaire',
        noneBody: 'Ce tableau familial n’a pas d’abonnement.',
        status: {
            trial: 'Mois d’essai',
            active: 'Actif',
            past_due: 'Paiement échoué',
            paused: 'En pause',
            cancelled: 'Résilié',
            expired: 'Consultation seule',
        },
        trialLeft: 'Encore {n} jours gratuits, jusqu’au {date} inclus.',
        trialLastDay: 'Aujourd’hui ({date}) est ton dernier jour gratuit.',
        activeUntil: 'Payé jusqu’au {date}.',
        activeOpen: 'Ton abonnement est en cours.',
        cancelledUntil: 'Résilié. Tout fonctionne encore jusqu’au {date} inclus.',
        expiredBody: 'Ton mois d’essai est terminé. Tout est encore là ; tu pourras modifier à nouveau après le paiement.',
        pastDueBody: 'Le dernier paiement a échoué. Ajoute à nouveau tes données de paiement.',
        pausedBody: 'AMUMIN a mis ton abonnement en pause un moment. Tout fonctionne normalement.',
        plan: 'Formule',
        perMonth: '{price} par mois',
        pricePlaceholder: 'Prix à venir',
        payment: 'Données de paiement',
        paymentNone: 'Pas encore de données de paiement.',
        paymentSet: 'Le prélèvement automatique est prêt.',
        addPayment: 'Ajouter des données de paiement',
        soon: 'Bientôt : payer avec iDEAL, puis par prélèvement automatique.',
        checkoutTitle: 'Ajouter des données de paiement',
        checkoutBody: 'Tu paies le premier mois avec iDEAL. Ensuite, nous prélevons automatiquement chaque mois. Tu peux résilier à tout moment.',
        startNow: 'Je veux que le service continue immédiatement. Si je me rétracte dans les 14 jours, je ne paie que les jours déjà utilisés.',
        startNowRequired: 'Coche cette case pour continuer.',
        toPayment: 'Vers le paiement',
        checkoutOpen: 'Un paiement est déjà en cours. Termine-le d’abord ou réessaie dans une heure.',
        paidReturn: 'Merci. Dès que le paiement est reçu, tu le verras ici.',
        invoices: 'Factures',
        invoicesNone: 'Pas encore de factures.',
        invoiceStatus: {
            open: 'Ouverte',
            paid: 'Payée',
            failed: 'Échouée',
            refunded: 'Remboursée',
            void: 'Annulée',
        },
        invoiceLine: '{number} · {period} · {amount}',
        cancel: 'Résilier l’abonnement',
        cancelTitle: 'Résilier l’abonnement ?',
        cancelBody: 'Tout fonctionne encore jusqu’au {date} inclus. Ensuite, tu peux encore tout consulter, mais plus rien modifier. Nous n’effaçons rien.',
        cancelConfirm: 'Oui, résilier',
        keep: 'Non, garder',
        cancelDone: 'Ton abonnement est résilié.',
        resume: 'Continuer finalement',
        resumeDone: 'Parfait, ton abonnement continue.',
        onlyOwner: 'Seul le propriétaire peut payer ou résilier.',
        deleteHint: 'Tu veux tout supprimer ? C’est possible dans Réglages › Tes données.',
    },
    banner: {
        expiredTitle: 'Ton mois d’essai est terminé',
        expiredBody: 'Tu peux encore tout consulter. Ajoute tes données de paiement pour pouvoir à nouveau ajouter et modifier.',
        pay: 'Payer',
        readOnly: 'Ton mois d’essai est terminé : tu pourras modifier à nouveau après le paiement.',
    },
    terms: {
        title: 'Conditions (projet)',
        intro: 'Ceci est un projet. Les conditions générales définitives figureront ici avant l’ouverture des inscriptions.',
        points: [
            'Le premier mois est gratuit. Tu n’as pas besoin de donner tes données de paiement pour cela.',
            'Ensuite, tu paies par mois ou par an, à l’avance. Tu peux résilier à tout moment ; l’abonnement court alors jusqu’à la fin de la période payée.',
            'Après le mois d’essai sans paiement, tu peux encore tout consulter, mais plus rien modifier. Nous n’effaçons jamais rien de nous-mêmes.',
            'En tant que consommateur, tu disposes d’un droit de rétractation de 14 jours à partir du moment où tu commences à payer.',
            'La façon dont nous traitons tes données est décrite dans la politique de confidentialité.',
        ],
    },
};
//# sourceMappingURL=billingApp.fr.js.map